import { Link } from "react-router-dom";
import { Form, Formik } from "formik";

import { Alert, colors, Grid, Icon, Typography } from "@mui/material";

import FormField from "layouts/pages/users/new-user/components/FormField";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

import { setMessage, useMaterialUIController } from "context";

import formWiclax from "../schema/formWiclax";
import { initicalValueWiclax } from "../schema/initicalValueWiclax";
import { validationWiclax } from "../schema/validationWiclax";

import { IResultadoCorrida } from "interfaces/resultadoCorrida";
import { addOrEditResultados } from "services/resultadoCorrida";

import { normalizeString } from "helpers/normalizeString";

interface Props {
  selectedEvento: IResultadoCorrida;
  isUpdate: () => void;
}

export default function FormWiclax({ selectedEvento, isUpdate }: Props) {
  const [, dispatch] = useMaterialUIController();
  const { filenameWiclax } = formWiclax;

  const dataForm = initicalValueWiclax(selectedEvento);

  // Copiar conteúdo para a área de transferencia
  const copyToClipboard = (text: string) => {
    if (!text) return;
    navigator.clipboard.writeText(text);
  };

  // Enviar dados para o backend para criação do arquivo
  const submitFormWiclax = async (values: any) => {
    try {
      await addOrEditResultados({
        filenameWiclax: `${values[filenameWiclax.name]}.clax`,
        // urllink: values[urllink.name],
        eventoId: selectedEvento.id,
      }).then(({ status }) => {
        // Atualizado arquivo wiclax
        if (status === 201) {
          setMessage(dispatch, {
            open: true,
            text: "Nome do arquivo Wiclax salvo com sucesso!",
            severity: "success",
          });
        }
        // Enviado novo arquivo wiclax
        if (status === 200) {
          setMessage(dispatch, {
            open: true,
            text: "Nome do arquivo Wiclax atualizado com sucesso!",
            severity: "info",
          });
        }
        isUpdate();
      });
    } catch (error: any) {
      setMessage(dispatch, {
        open: true,
        text: error.message,
        severity: "error",
      });
    }
  };

  // Desvincular o arquivo
  const handleDesvincularFile = async () => {
    await addOrEditResultados({
      filenameWiclax: null,
      eventoId: selectedEvento.id,
    });
    isUpdate();
  };

  return (
    <MDBox
      sx={{
        p: 4,
        my: 4,
        backgroundColor: colors.grey[50],
        borderRadius: "6px",
        border: `1px solid ${colors.grey[400]}`,
      }}
    >
      <Formik
        initialValues={dataForm}
        validationSchema={validationWiclax}
        onSubmit={(values) => {
          submitFormWiclax(values);
        }}
      >
        {({ values, handleChange, setFieldValue }) => (
          <Form id="form-wiclax">
            <MDBox
              sx={{
                mb: 4,
                borderLeft: `4px solid ${colors.orange[400]}`,
                pl: 1,
              }}
            >
              <Typography variant="body2">
                Defina o nome do arquivo ao criar o evento no programa Wiclax,
                certificando-se de que o arquivo seja salvo com o mesmo nome.
                Isso é importante porque, ao enviar o resultado, ele será
                transferido para o FTP do Wiclax com esse nome específico.
              </Typography>
            </MDBox>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={10}>
                <FormField
                  name={filenameWiclax.name}
                  label={filenameWiclax.label}
                  type={filenameWiclax.type}
                  variant="outlined"
                  value={values[filenameWiclax.name]}
                  onChange={handleChange}
                  placeholder="Nome do arquivo Wiclax"
                  InputLabelProps={{ shrink: true }}
                  onBlur={() =>
                    setFieldValue(
                      filenameWiclax.name,
                      normalizeString(values[filenameWiclax.name])
                    )
                  }
                  sx={{ background: "white" }}
                />
                <Alert severity="info">
                  Este é o nome sugerido para seu arquivo
                </Alert>
              </Grid>
              <Grid item xs={12} sm={2}>
                <MDButton
                  variant="outlined"
                  color="warning"
                  size="small"
                  onClick={() => copyToClipboard(values[filenameWiclax.name])}
                >
                  <Icon>copy</Icon> Copiar
                </MDButton>
              </Grid>
            </Grid>

            {/* <MDBox sx={{ my: 2, borderLeft: `4px solid ${colors.orange[400]}`, pl: 1 }}>
              <Typography variant="body2">
                Definir o link das fotos do evento, cole o link da url no campo abaixo
              </Typography>
            </MDBox>

            <FormField
              name={urllink.name}
              label={urllink.label}
              type={urllink.type}
              value={values[urllink.name]}
              onChange={handleChange}
              placeholder="https://..."
              variant="outlined"
              sx={{ background: "white" }}
            /> */}
            <MDBox
              display="flex"
              justifyContent="flex-end"
              gap={2}
              sx={{ mt: 3 }}
            >
              {selectedEvento?.resultado?.filenameWiclax && (
                <MDBox
                  display="flex"
                  justifyContent="space-between"
                  width="100%"
                  alignItems={"center"}
                >
                  <Link
                    to={`https://www.tnvteam.com.br/glive/${selectedEvento.slug}`}
                    target="_blank"
                    rel="noopener"
                    title={selectedEvento?.slug}
                  >
                    <MDBox display="flex" alignItems="center" gap={1}>
                      <Icon color="secondary" fontSize="medium">
                        link
                      </Icon>
                      <Typography variant="body2">
                        {selectedEvento?.slug}
                      </Typography>
                    </MDBox>
                  </Link>

                  <MDButton
                    variant="outlined"
                    color="info"
                    onClick={handleDesvincularFile}
                  >
                    Desvincular arquivo
                  </MDButton>
                </MDBox>
              )}
              <MDButton variant="gradient" color="success" type="submit">
                {selectedEvento?.resultado?.filenameWiclax
                  ? "Atualizar"
                  : "Salvar"}
              </MDButton>
            </MDBox>
          </Form>
        )}
      </Formik>
    </MDBox>
  );
}
